import { useMetricCollector } from "@/composables/use-metric-collector";
const { addMetric, initGathering, beforeUnloadListener } = useMetricCollector()

initGathering()

window.addEventListener("beforeunload", beforeUnloadListener)

const supabaseUrl = new URL((window as any).ENV_SUPABASE_URL)
const tableNameRegex = /\/rest\/v1\/(rpc\/)?(\w+)/
const relayHost = new URL((window as any).ENV_RELAY_HOST)
const manualActionsRegex = /\/integrations\/(sync|async)\/actions/
window.addEventListener('fetch-timing', (event) => {
  const { url, method, payload, timing, err } = (event as CustomEvent).detail
  if(method === 'HEAD')
    return
  const isSupabase = url.startsWith(supabaseUrl)
  const isRelay = url.startsWith(relayHost)
  if(!isSupabase && !isRelay)
    return
  if(isSupabase) {
    if(err) {
      addMetric('technical_errors', 1, {
        error_type: 'exception',
        error_name: 'DB_QUERY_ERROR'
      })
      return
    }
    const matches = url.match(tableNameRegex)
    const tableName = matches?.[2]
    if(tableName?.length) {
      addMetric('db_query_ms', timing, {
        table_name: tableName,
        filters: 'none', // TODO
        query_duration_hours: 'none', // TODO
        returned_records_count: 0 // TODO
      })
    }
  } else if(isRelay) {
    if(err) {
      addMetric('technical_errors', 1, {
        error_type: 'exception',
        error_name: 'MANUAL_ACTION_ERROR'
      })
      return
    }
    if(url.match(manualActionsRegex)) {
      const actionName = payload?.body?.action_name
      if(actionName?.length) {
        addMetric('manual_actions_query_ms', timing, {
          action_name: actionName,
          extra_info: 'none', // TODO
        })
      }
    }
  }
})
